import { render } from "./purchaseList.vue?vue&type=template&id=8b557258&scoped=true"
import script from "./purchaseList.vue?vue&type=script&lang=js"
export * from "./purchaseList.vue?vue&type=script&lang=js"

import "./purchaseList.vue?vue&type=style&index=0&id=8b557258&scoped=true&lang=css"
import "./purchaseList.vue?vue&type=style&index=1&id=8b557258&lang=css"

import exportComponent from "/home/LiuJing/code/MyProjects/YiZhiWang/yizhiwang_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b557258"]])

export default __exports__